import { motion } from 'framer-motion'

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } },
}

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
}

const services = [
  {
    icon: (
      <img src="/service-qa.png" className="w-8 h-8 object-contain" alt="" />
    ),
    title: 'QA & Testausautomaatio',
    description:
      'Rakennamme kattavat testausautomaatioratkaisut, jotka löytävät virheet ennen tuotantoa. Robot Framework, Cypress, Playwright ja CI/CD-integraatiot — kaikki saman katon alta.',
    tags: ['Robot Framework', 'Cypress', 'Python', 'CI/CD'],
  },
  {
    icon: (
      <img src="/service-dev.png" className="w-8 h-8 object-contain" alt="" />
    ),
    title: 'Ohjelmistokehitys',
    description:
      'Full-stack-kehitystä Python- ja TypeScript-ekosysteemeissä. Sulautetuista järjestelmistä web-sovelluksiin, pragmaattinen lähestymistapa, joka sopii projektin tarpeisiin.',
    tags: ['Python', 'TypeScript', 'Backend', 'Frontend'],
  },
  {
    icon: (
      <img src="/service-aws.png" className="w-8 h-8 object-contain" alt="" />
    ),
    title: 'AWS-pilvipalvelut',
    description:
      'Arkkitehtuurisuunnittelu, infrastruktuuri koodina (CDK/Terraform) ja operatiivinen tuki. Neljä AWS-sertifikaattia takaa, että pilvi toimii oikein.',
    tags: ['AWS CDK', 'IaC', 'DevOps', 'IoT'],
  },
]

export default function Services() {
  return (
    <section
      id="palvelut"
      className="py-24 lg:py-32 bg-gray-50 dark:bg-gray-900/50"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wider">
            Palvelut
          </span>
          <h2 className="mt-2 text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white">
            Tätä teen
          </h2>
          <p className="mt-4 text-base text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
            Kevyt rakenne tarkoittaa, että jokainen euro menee suoraan osaamiseen —
            ei hallintoon tai ylikapasiteettiin.
          </p>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {services.map(({ icon, title, description, tags }) => (
            <motion.div
              key={title}
              variants={fadeUp}
              className="group relative bg-white dark:bg-gray-900 rounded-2xl p-8 shadow-sm border border-gray-100 dark:border-gray-800 hover:shadow-md hover:border-blue-100 dark:hover:border-blue-900 transition-all duration-300"
            >
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 mb-6 group-hover:scale-110 transition-transform duration-300">
                {icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-3">{title}</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-5">
                {description}
              </p>
              <div className="flex flex-wrap gap-2">
                {tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs font-medium px-2.5 py-1 rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
